var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/2-User"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M9.68667 15.5703C4.73191 15.5703 0.5 16.3357 0.5 19.3949C0.5 22.4564 4.705 23.2481 9.68667 23.2481C14.6414 23.2481 18.8733 22.4828 18.8733 19.4236C18.8733 16.3621 14.6683 15.5703 9.68667 15.5703Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    opacity: 0.4,
    d: "M9.6862 12.656C13.0607 12.656 15.765 10.0077 15.765 6.70301C15.765 3.39831 13.0607 0.75 9.6862 0.75C6.31291 0.75 3.60742 3.39831 3.60742 6.70301C3.60742 10.0077 6.31291 12.656 9.6862 12.656Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    opacity: 0.4,
    d: "M18.2175 6.81274C18.2175 8.49564 17.7013 10.0659 16.7962 11.3703C16.702 11.5045 16.7852 11.6854 16.9491 11.7141C17.1766 11.7512 17.4102 11.774 17.6487 11.7788C20.0215 11.8399 22.1509 10.3438 22.7392 8.09079C23.6113 4.74775 21.0526 1.74609 17.793 1.74609C17.4396 1.74609 17.1008 1.78203 16.7705 1.84791C16.7253 1.85749 16.6764 1.87905 16.6519 1.91738C16.6201 1.96649 16.6433 2.02997 16.6751 2.07189C17.6548 3.41701 18.2175 5.05439 18.2175 6.81274Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M25.2231 15.9627C24.7889 15.0559 23.7407 14.4343 22.1458 14.1288C21.3936 13.9492 19.3559 13.694 17.4613 13.73C17.4332 13.7336 17.4173 13.7527 17.4148 13.7647C17.4112 13.7839 17.4197 13.8126 17.4564 13.833C18.3322 14.257 21.7165 16.1016 21.2908 19.992C21.2725 20.1621 21.4107 20.3058 21.5831 20.2819C22.4161 20.1657 24.5589 19.7141 25.2231 18.3103C25.5912 17.5677 25.5912 16.7053 25.2231 15.9627Z",
    fill: "#C4C4C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgents);
export default __webpack_public_path__ + "static/media/agents.e25ca1f948fca4486be37cfd33ec57d5.svg";
export { ForwardRef as ReactComponent };